import React from 'react';
import styles from '../landing.module.scss';
import { FaRocket, FaChartPie, FaMoneyBillWave, FaMoneyBill, FaMoneyCheck } from 'react-icons/fa';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ListStart } from 'lucide-react';

// Login Redirect Utility
import { navigateToRegister } from '../../../utils/loginRedirect';

const FooterCTA = () => {
    const location = useLocation();
    const navigate = useNavigate();

    return (
        // <section className={styles.footerCTASection}>
        //     <div className={styles.container}>
        //         <div className={styles.ctaContents}>
        //             <h2>Everything you need to grow in VR</h2>
        //             <p>From keyword visibility to competitor performance, KeyQuest provides the market insights you need to launch, optimize, and scale your VR games across the Meta Quest ecosystem.</p>
        //             <div className={styles.ctaButtons}>
        //                 <Link to="/register" className={`${styles.btn} ${styles.btnPrimary}`}>
        //                     <FaRocket /> Start exploring the VR market for free
        //                 </Link>
        //                 <Link to="/profile/plans" className={`${styles.btn} ${styles.btnSecondary}`}>
        //                     <FaChartPie /> Analyze your first game with our plans
        //                 </Link>
        //             </div>
        //         </div>
        //     </div>
        //     <div className={styles.footerBlobRight}></div>
        // </section>

        <section className={styles.midCTASection}>
            <div className={styles.container}>
                <div className={styles.ctaContent}>
                    <h2>Everything you need to grow in VR</h2>
                    <p>From keyword visibility to competitor performance, KeyQuest provides the market insights you need to launch, optimize, and scale your VR games across the Meta Quest ecosystem.</p>
                    <div className={styles.ctaButtons}>
                        <button 
                            onClick={() => navigateToRegister(location.pathname, navigate)}
                            className={`${styles.btn} ${styles.btnPrimary}`}
                        >
                            <ListStart /> Get started with KeyQuest
                        </button>
                        <Link to="/profile/plans" className={`${styles.btn} ${styles.btnSecondary}`}>
                            <FaMoneyCheck /> Try the Premium version for free
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FooterCTA;
